(function () {
  'use strict';

  angular.module('ringbaPortal').component('tagTree', {
    bindings: {
      tags: '<',
      tagSource: '<',
      forSearch: '<',
      multipleTagsSelection: '<',
      selectedTags: '<',
      onSelectTag: '&',
      onUnselectedTag: '&',
    },
    controller: TagTreeController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/tag-tree/tag-tree.view.html'
  });

  function TagTreeController(
    _,
    $filter,
    tagService
  ) {
    'ngInject';

    const vm = this;

    vm.expandCollapseTypesTree = {};
    vm.$onChanges = onChanges;
    vm.translate = translate;
    vm.onClickedTag = onClickedTag;

    const translationString = {
      'Address:Caller Profile': {
        'name': 'ADDRESS_CALLER_PROFILE_ZIPCODE',
        'description': 'ADDRESS_CALLER_PROFILE_ZIPCODE_DESCRIPTION'
      },
      'gather:IVR': {
        'name': 'GATHER_IVR_ZIPCODE',
        'description': 'GATHER_IVR_ZIPCODE_DESCRIPTION'
      },
      'Geo:JSTag': {
        'name': 'GEO_JSTAG_ZIPCODE',
        'description': 'GEO_JSTAG_ZIPCODE_DESCRIPTION'
      },
      'InboundNumber:Call': {
        'name': 'INBOUND_CALLER_AREACODE_ZIPCODE',
        'description': 'INBOUND_CALLER_AREACODE_ZIPCODE_DESCRIPTION'
      },
    };

    function onChanges() {
      _groupTags(angular.copy(vm.tags));
    }

    function onClickedTag(tag) {
      if (vm.selectedTags[_normalizeTagType(tag) + ':' + tag.tagName]) {
        vm.onSelectTag({ tag: tag, keepExisting: true });
      } else {
        vm.onUnselectedTag({ tag: tag });
      }
    }

    function translate(tag, description) {
      const tagKey = tag.tagType + ':' + tag.tagName;
      if(translationString[tagKey]) {
        return $filter('translate')(description == true ?  translationString[tagKey].description : translationString[tagKey].name);
      }

      return $filter('camelCaseFormat')(description == true ? '' : tagKey);
    }

    function _groupTags(tags) {
      if (tags && tags.length) {
        vm.groupedTags = {};

        tags = tagService.filterByTagSource(tags, vm.tagSource);

        vm.groupedTags = _.groupBy(tags, function (tag) {
          const camelCasedTagType = _normalizeTagType(tag);
          // Keep the tree expanded when user searches for a tag
          if (vm.forSearch && !vm.expandCollapseTypesTree[tag.tagType]) {
            vm.expandCollapseTypesTree[camelCasedTagType] = true;
          }

          return camelCasedTagType;
        });

        vm.tagTypes = Object.keys(vm.groupedTags).sort();
      } else {
        vm.groupedTags = null;
        vm.tagTypes = null;
      }
    }

    function _normalizeTagType(tag) {
      return $filter('camelCaseFormat')(tag.tagType);
    }
  }
})();
